import { useEffect, useState } from 'react';
import { Api } from '../../../componentes/Api';
import { Card, CardBody, Row, Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"


const modeloDatos = {
    almacenID: 0,
    empresaID: "",
    descripcion: "",
    ubicacionID: 1,
    activo: true,
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date

}

const InformesVentas = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [ListadoReporte, SetListadoReporte] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);



    const obtenerDatos = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaAlmacen");

        if (response.ok) {
            let data = await response.json()
            SetListado(data)
            setPendiente(false)
        }
    }
    const obtenerReportes = async () => {
        let response = await fetch(Api + "Administracion/Reporteria/4");

        if (response.ok) {
            let data = await response.json()
            SetListadoReporte(data)

        }
    }

    useEffect(() => {
        obtenerDatos();
        obtenerReportes()
    }, [])

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }
    const Reporte = (e) => {
        window.open("/impresionCXC/" + e, '_blank');
    }


    return (
        <>
       
            <div class="reporting-container">
                {ListadoReporte.map(x => (
                    <button class="report-button inventory" onClick={() => Reporte(x.reporteID)}>
                        <i class="fas fa-boxes"></i>  {x.nombreBoton}
                    </button>

                ))}
            </div>
        </>
    )

}
export default InformesVentas;